/*
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2021-11-26 15:32:33
 * @LastEditors: Li Yong
 * @LastEditTime: 2021-12-16 20:33:02
 */
import request from '@/utils/request'
import { AjaxMethod } from '@/utils/dataMap'

// 工作台数据
export const partnerPersonal = (params) => {
    return request({
        url: '/api/partner/personal',
        data: params,
        method: AjaxMethod.post
    })
}

// 绑定微信
export const bindqr = (params) => {
    return request({
        url: '/api/partner/bind-qr',
        data: params,
        method: AjaxMethod.post
    })
}

// 解绑微信
export const unbind = (params) => {
    return request({
        url: '/api/partner/un-bind',
        data: params,
        method: AjaxMethod.post
    })
}

// 是否绑定微信
export const checkBind = (params) => {
    return request({
        url: '/api/partner/check-bind',
        data: params,
        method: AjaxMethod.post
    })
}

// 开启公众号通知
export const acceptOn = (params) => {
    return request({
        url: '/api/partner/accept-on',
        data: params,
        method: AjaxMethod.post
    })
}

// 关闭公众号通知
export const acceptOff = (params) => {
    return request({
        url: '/api/partner/accept-off',
        data: params,
        method: AjaxMethod.post
    })
}

